import React, { useEffect, useContext, useState, useRef } from 'react'
import { csvFormat } from '../../../../utils/csvSur' // B47 : export sans formule
import Moment from 'moment'

import exportButtonSVG from '../../../../images/export-button.svg'
import exportButtonQuestionsSVG from '../../../../images/exportQuestions-button.svg'
import loadingGIF from '../../../../images/loading.gif'

import {
  Box,
} from '@mui/material';

import APIS from "../../../../utils/APIS"



const UsersResult = ({ icebreaker, plan, group }) => {

  const [actPlan, setActPlan] = useState(null)

  const [groupUsers, setGroupesUsers] = useState([])

  const [actEngagement, setActEngagement] = useState([])
  const [actResults, setActResults] = useState([])

  useEffect(() => {
    APIS.getGroupeUsers( { id:group?.id }).then((results) => {
      setGroupesUsers(results)
    })
  }, [group])

  useEffect(() => {
    if (plan && icebreaker && group) {
      let newPlan = JSON.parse(JSON.stringify(plan));
      let iceBreakerItem = {
        openDate : '2023-01-01',
        closeDate : '2999-01-01',
        name : '"ICEBREAKER"',
        id : 60,
        surname : '"ICEBREAKER"',
        color : '#ef9d10',
      }

      if (group?.isTheScanGroupe !== 1) {
        if (icebreaker !== null) {
          iceBreakerItem.id = icebreaker
        }
        newPlan.splice(0, 0, iceBreakerItem);
      }

      //engagements
      let values = []
      if (groupUsers?.length === 0) {
        values = [{nbr : 0, label : "..."}]
        newPlan.forEach((p) => {
          values.push({nbr : 0, label : "..."})
        })
      } else {
        //engagement
        let nbrDejaConnecte = groupUsers?.filter((el) => {
          if (el.lastConnection === null) {
            let findInProgress = el?.formations?.find((el2) => el2.progress > 0)
            if (findInProgress) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        })?.length
        let tauxEngagement = (nbrDejaConnecte / groupUsers?.length) * 100
        values[0] = {nbr : nbrDejaConnecte, label : Math.round(tauxEngagement * 100) / 100}
        //modules
        newPlan.forEach((formation, index) => {
          let indexValues = index+1
          let nbrTermine = groupUsers?.filter((el) => {
            let find = el?.formations?.find((el2) => el2.id === formation.id && el2.progress === 100 && el2.isDone === true)
            return find
          })?.length
          let percent = 0
          if (values[indexValues-1]?.nbr !== 0) {
            percent = (nbrTermine / values[indexValues-1]?.nbr) * 100
          }
          values[indexValues] = {nbr : nbrTermine, label : Math.round(percent * 100) / 100}
        })
      }

      setActEngagement(values)

      //usersResults
      let newResults = []
      groupUsers?.forEach((user) => {

        let res = []
        newPlan?.forEach((plan) => {
          let findForUser = user?.formations?.find((el) => el.id === plan.id)
          if (findForUser) {
            if (findForUser?.resultFin !== null) {
              //terminé
              try {
                let resultFin = JSON.parse(findForUser?.resultFin)
                if (resultFin?.glbMaster?.score !== undefined && resultFin?.glbMaster?.score !== null) {
                  res.push({
                    statut : "ended",
                    score : resultFin?.glbMaster?.score,
                    maxPoints : resultFin?.glbMaster?.max,
                    nbrPoints : resultFin?.glbMaster?.points,
                  })
                } else if (resultFin?.master?.score !== undefined && resultFin?.master?.score !== null) {
                  res.push({
                    statut : "ended",
                    score : resultFin?.master?.score,
                    maxPoints : resultFin?.master?.max,
                    nbrPoints : resultFin?.master?.points,
                  })
                }
              } catch(e) {
                //erreur
                res.push({statut : "notFind"})
              }
            } else {
              //en cours
              res.push({statut : "inProgress", progress : findForUser?.progress})
            }
          } else {
            //pas commencé
            res.push({statut : "notFind"})
          }
        })

        newResults.push({
          name : user?.name,
          res : res
        })
      })
      setActResults(newResults)


      setActPlan(newPlan)
    }
  }, [plan, icebreaker, group, groupUsers])


  const exportResult = async (e, newPlan, index) => {
    //console.log(e.target)
    let element = null;
    if (e.target) {
      e.target.classList.add('svgExportLoading')
      e.target.src = loadingGIF
      element = e.target
    }
    let globalResults = []
    let userIDs = []
    let exportPlan = newPlan[index];
    let icebreakerID = newPlan[0]?.id;
    groupUsers?.forEach((user) => {
      let findFormation = user.formations.find((formation) => formation.id === exportPlan.id)
      if (findFormation) {
        //if (findFormation.resultFin !== null) { //si le user a terminé la formation
          exportPlan.formationID = findFormation.id
          let lastConnection = null;
          try {
            let parseLastConnection = JSON.parse(user.lastConnection)
            if (parseLastConnection.length > 0) {
              lastConnection = Moment(parseLastConnection[parseLastConnection.length-1]).format('DD/MM/YYYY')
            }
          } catch(e) {}
          let vals = {
            userID : user.id,
            name : user.name,
            naissance : Moment(user.naissance).format('DD/MM/YYYY'),
            sexe : user.sexe === 0 ? "Femme" : "Homme",
            departement : user.departement,
            formation : findFormation,
            lastConnection : lastConnection,
            secteur : null,
            annee : null,
            diplome : null,
          }
          //on va chercher les résultats des questions icebreaker
          let icebreakerFormation = user.formations.find((formation) => formation.id === icebreakerID)
          if (icebreakerFormation) {
            try {
              let userResult = JSON.parse(icebreakerFormation.userResult)
              vals.secteur = userResult?.secteurs || null
              vals.annee = userResult?.annees || null
              vals.diplome = userResult?.diplome || null
            } catch(e) {}
          }
          globalResults.push(vals)
          userIDs.push(user.id)
        //}
      }
    })

    //on verifie si on a au moins un user pour cette formation
    if (globalResults.length > 0) {
      //on va chercher les infos de la formation
      let content = await APIS.getContentByIdForAdmin({id : exportPlan.formationID})
      //on retrouve les ids des chapitres/parties/sequences
      let chapIDs = []
      let partIDs = []
      let seqIDs = []
      content.chapitre.forEach((chap) => {
        chapIDs.push(chap.id)
        chap.partie.forEach((part) => {
          partIDs.push(part.id)
          part.sequence.forEach((seq) => {
            seqIDs.push(seq.id)
          })
        })
      })

      let results = await APIS.getGroupeUsersResults({
        chapIDs : chapIDs,
        partIDs : partIDs,
        seqIDs : seqIDs,
        userIDs : userIDs
      })

      let toAddToExport = []
      let catsListArr = []
      content.chapitre.forEach((chap) => {
        chap.allResults = results.chapters.filter((el) => el.chapterID === chap.id)
        chap.partie.forEach((part) => {
          part.allResults = results.parts.filter((el) => el.partID === part.id)
          part.sequence.forEach((seq) => {
            seq.allResults = results.seqs.filter((el) => el.sequenceID === seq.id)
            //on va chercher toutes les séquences de type "questionnaire" / "questionnaireV2" / "Quizz"
            if (seq.type === "Questionnaire" ||seq.type === "QuestionnaireV2" || seq.type === "Quizz" || seq.type === "InputTexte") {
              seq.partTitle = part.title;
              seq.chapTitle = chap.title;
              //on regarde pour la catégorie et la numérotation
              let catSeq = "unknown"
              if (seq.categorie) {
                catSeq = seq.categorie
              }
              seq.catForExport = catSeq
              let findInCatsArr = catsListArr.find((el) => el.cat === catSeq)
              if (findInCatsArr) {
                findInCatsArr.nbr = findInCatsArr.nbr+1;
                seq.nbrInCat = findInCatsArr.nbr;
              } else {
                catsListArr.push({
                  cat : catSeq,
                  nbr : 1
                })
                seq.nbrInCat = 1
              }
              toAddToExport.push(seq)
            }
          })
        });
      })

      /* exports */
      const renameKeys = (keysMap, objs) => {
        for (let i=0; i<objs.length;i++) {
          let obj = objs[i]
          objs[i] = Object.keys(obj).reduce(
          (acc, key) => ({
              ...acc,
              ...{ [keysMap[key] || key]: obj[key] }
          }),
          {})
        }
        return objs
      }

      let filename = 'Export Results Formation ' + exportPlan.name + ' le ' + Moment().format('DD-MM-YYYY') + ' à ' + Moment().format('HH-mm')
      let fieldsRename = {
        userID : "userID",
        name : "Nom",
        naissance : "Date de naissance",
        sexe : "Sexe",
        departement : "Code Postal",
        lastConnection : "Dernière connexion",
        secteur : "Secteurs",
        annee : "Années d'études",
        diplome : "Diplome",

      }
      let fieldsExport = [
        "userID",
        "Nom",
        "Date de naissance",
        "Sexe",
        "Code Postal",
        "Dernière connexion",
        "Secteurs",
        "Années d'études",
        "Diplome",
      ]
      //on ajoute chaque question dans le tableau
      let fakeID = 1;
      toAddToExport.forEach((el) => {
        //let questionName = el.chapTitle + "_" + el.partTitle + "_Q" + el.questionNumber + "_" + el.type;
        //let questionName = fakeID + " : "+ el.questions
        let questionName = el.catForExport + "_" + el.nbrInCat.toString().padStart(2, "0") + "_" + el.questions
        fakeID++;
        if (el.type === "QuestionnaireV2") {
          fieldsExport.push(questionName+"_score")
          fieldsExport.push(questionName+"_rep")
        } else if (el.type === "Questionnaire") {
          fieldsExport.push(questionName)
        } else if (el.type === "Quizz") {
          fieldsExport.push(questionName+"_score")
          fieldsExport.push(questionName+"_rep")
        } else if (el.type === "InputTexte") {
          fieldsExport.push(questionName)
        }
        //console.log(questionName + " :")
        globalResults.forEach((glbRes) => {
          let result = el.allResults.find((res) => res.userID === glbRes.userID)
          if (result) {
            if (el.type === "QuestionnaireV2") {
              try {
                let res = el.responses[JSON.parse(result.userChoice)[0]]
                //glbRes[questionName] = res.label + " ( " + res.points + " points)"
                glbRes[questionName+"_score"] = res.points
                glbRes[questionName+"_rep"] = res.label
              } catch (e) {}
            } else if (el.type === "Questionnaire") {
              glbRes[questionName] = result.userChoice
            } else if (el.type === "Quizz") {
              if (el.noValidAnswer === true) {
                //quizz sans bonne réponse, on donne simplement le/les label de réponse(s)
                let res = JSON.parse(result.userChoice)
                let str = ""
                let score = 0;
                if (res !== null) {

                  res.forEach((r, index) => { //forEach pour si on est en multi === true
                    if (index !== 0) {
                      str += '\n' //on passe à la ligne à partir de la 2nd réponse
                    }
                    str += el.responses[parseInt(r)].reponse
                    score += el.responses[parseInt(r)].points
                  })
                  glbRes[questionName+"_score"] = score
                  glbRes[questionName+"_rep"] = str
                }
              } else {
                //quizz avec bonne réponse, on compte les points
                let res = JSON.parse(result.userChoice)
                let totalPoints = 0;
                let str = ""
                if (res !== null) {
                  res.forEach((r, index) => { //forEach pour si on est en multi === true
                    if (index !== 0) {
                      str += '\n' //on passe à la ligne à partir de la 2nd réponse
                    }
                    str += el.responses[parseInt(r)].reponse
                    if (el.responses[parseInt(r)].points) {
                      totalPoints += el.responses[parseInt(r)].points
                    } else {
                      totalPoints += 0;
                    }
                  });
                  glbRes[questionName+"_score"] = totalPoints
                  glbRes[questionName+"_rep"] = str
                  //glbRes[questionName] = totalPoints + ' points'
                }
              }

            } else if (el.type === "InputTexte") {
              try {
                glbRes[questionName] = JSON.parse(result.userChoice)
              } catch(e) {}
            }
            //console.log(glbRes[questionName])
            //console.log("")
          }
        })
      })

      //on ajoute chaque catégorie de résultat dans le tableau
      globalResults.forEach((el) => {
        try {
          let parseResultFin = JSON.parse(el.formation.resultFin)
          Object.keys(parseResultFin).forEach(function(k, v) {
            //points
            let finalName = 'Categorie '+k+'_points'
            if (fieldsExport.includes(finalName) === false) {
              fieldsExport.push(finalName)
            }
            //el[finalName] = parseResultFin[k].points + " / " + parseResultFin[k].max  + " points (" +parseResultFin[k].score+ " %)"
            el[finalName] = parseResultFin[k].points + " / " + parseResultFin[k].max
            //score
            let finalName2 = 'Categorie '+k+'_pourcentage'
            if (fieldsExport.includes(finalName2) === false) {
              fieldsExport.push(finalName2)
            }
            el[finalName2] = parseResultFin[k].score
          });
        } catch(e) { }
      })


      let rename = renameKeys(fieldsRename,  globalResults);
      let csv = csvFormat(rename, fieldsExport);
      var link = document.createElement('a');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
      link.setAttribute('download', filename+'.csv');
      link.style.visibility = 'hidden';
      if (element) {
        element.classList.remove('svgExportLoading')
        element.src = exportButtonSVG
      }
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      if (element) {
        element.classList.remove('svgExportLoading')
        element.src = exportButtonSVG
      }
      alert ("Pas de résultats à afficher")
    }
  }

  const exportResultQuestons = async (e, newPlan, index) => {
    //console.log(e.target)
    let element = null;
    if (e.target) {
      e.target.classList.add('svgExportLoading')
      e.target.src = loadingGIF
      element = e.target
    }

    let globalResults = []
    let content = await APIS.getContentByIdForAdmin({id : newPlan[index].id})

    //on retrouve les ids des chapitres/parties/sequences
    let chapIDs = []
    let partIDs = []
    let seqIDs = []
    content.chapitre.forEach((chap) => {
      chapIDs.push(chap.id)
      chap.partie.forEach((part) => {
        partIDs.push(part.id)
        part.sequence.forEach((seq) => {
          seqIDs.push(seq.id)
        })
      })
    })

    let toAddToExport = []
    let catsListArr = []
    let maxNbrRep = 0;
    content.chapitre.forEach((chap) => {
      chap.partie.forEach((part) => {
        part.sequence.forEach((seq) => {
          //on va chercher toutes les séquences de type "questionnaire" / "questionnaireV2" / "Quizz"
          if (seq.type === "Questionnaire" ||seq.type === "QuestionnaireV2" || seq.type === "Quizz" || seq.type === "InputTexte") {
            seq.partTitle = part.title;
            seq.chapTitle = chap.title;
            //on regarde pour la catégorie et la numérotation
            let catSeq = "unknown"
            if (seq.categorie) {
              catSeq = seq.categorie
            }
            seq.catForExport = catSeq
            let findInCatsArr = catsListArr.find((el) => el.cat === catSeq)
            if (findInCatsArr) {
              findInCatsArr.nbr = findInCatsArr.nbr+1;
              seq.nbrInCat = findInCatsArr.nbr;
            } else {
              catsListArr.push({
                cat : catSeq,
                nbr : 1
              })
              seq.nbrInCat = 1
            }
            if (seq.responses?.length > maxNbrRep) {
              maxNbrRep = seq.responses.length
            }
            toAddToExport.push(seq)
          }
        })
      });
    })

    const renameKeys = (keysMap, objs) => {
      for (let i=0; i<objs.length;i++) {
        let obj = objs[i]
        objs[i] = Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: obj[key] }
        }),
        {})
      }
      return objs
    }
    let filename = 'Export Liste Formation ' + newPlan[index].name + ' le ' + Moment().format('DD-MM-YYYY') + ' à ' + Moment().format('HH-mm')
    let fieldsRename = {
      identifier : "Cat_NumDansCat",
      phrase : "Phrase",
      catForExport : "Catégorie",
      type : "Type",
    }
    let fieldsExport = [
      "Cat_NumDansCat",
      "Phrase",
      "Catégorie",
      "Type",
    ]

    for (let i=0; i<maxNbrRep; i++) {
      fieldsExport.push("Response"+i)
    }
    for (let i=0; i<maxNbrRep; i++) {
      fieldsExport.push("Point"+i)
    }

    let fakeID = 1;
    toAddToExport.forEach((el) => {
      let newElem = {
        identifier : el.catForExport + "_" + el.nbrInCat.toString().padStart(2, "0"),
        phrase : el.questions,
        catForExport : el.catForExport,
        type : el.type,
      }
      if (el.responses && el.responses.length) {
        for (let i=0; i<el.responses.length; i++) {
          newElem["Response"+i] = el.responses[i]?.label || el.responses[i]?.reponse
          newElem["Point"+i] = el.responses[i]?.points
        }
      }
      globalResults.push(newElem)
    })

    let rename = renameKeys(fieldsRename,  globalResults);
    let csv = csvFormat(rename, fieldsExport);
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename+'.csv');
    link.style.visibility = 'hidden';
    if (element) {
      element.classList.remove('svgExportLoading')
      element.src = exportButtonQuestionsSVG
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }



  return (
    <>
      <Box sx={{
        boxShadow:"0 0 10px #7c7c7c4f",
        minHeight:"74px",
        margin : "0 10px 30px",
        display:"flex",
        flexDirection:"column",
      }}>
        <Box sx={{
          display:"flex",
          alignItemps:"center",
          justifyContent:"space-around",
          padding:"10px 20px",
          background:"#d5d5d521",
          "& span" : {
            width:"100%",
            fontWeight:"bold",
            fontSize:"14px"
          },
        }}>
          <span>Taux d'activation</span>
          {actPlan?.map((formation, index) => {
            let texte = ""
            if (index === 0) {
              texte = "Taux de lancement"
            } else if (index === (actPlan?.length - 1)) {
              texte = "Taux de rétention"
            } else {
              texte = "Taux d'engagement"
            }
            return (
              <span key={index}>
                {texte}
              </span>
            )
          })}

        </Box>
        <Box sx={{maxHeight:"100%"}}>
          <Box sx={{
            display:"flex",
            alignItemps:"center",
            justifyContent:"space-around",
            padding:"10px 20px",
            "& span" : {
              width:"100%",
              fontSize:"13px"
            },
          }}>
            {(actPlan?.length === actEngagement?.length - 1) &&
              <>
                <span>
                  {actEngagement[0]?.label+" %"} ({actEngagement[0]?.nbr})
                </span>
                {actPlan.map((formation, index) => {
                  return (
                    <span key={index}>
                      {actEngagement[index+1]?.label+" %"} ({actEngagement[index+1]?.nbr})
                    </span>
                  )
                })}
              </>
            }
          </Box>
        </Box>
      </Box>


      <Box sx={{
        boxShadow:"0 0 10px #7c7c7c4f",
        minHeight:"74px",
        margin : "0 10px 30px",
        display:"flex",
        flexDirection:"column",
      }}>
        <Box sx={{
          display:"flex",
          alignItemps:"center",
          justifyContent:"space-around",
          padding:"10px 20px",
          background:"#d5d5d521",
          "& span" : {
            width:"100%",
            fontWeight:"bold",
            fontSize:"14px"
          },
        }}>
          <span>Nom</span>
          {actPlan?.map((formation, index) => {
            return (
              <span key={index} style={{
                display:"flex"
              }}>
                {actPlan[index]?.surname}
                {' '}
                <img src={exportButtonSVG} style={{marginLeft:"3px", width:"13px", cursor:"pointer"}} onClick={(e) => {
                  exportResult(e, actPlan, index)
                }}/>
                <img src={exportButtonQuestionsSVG} style={{marginLeft:"5px", width:"13px", cursor:"pointer"}} onClick={(e) => {
                  exportResultQuestons(e, actPlan, index)
                }}/>
              </span>
            )
          })}

        </Box>
        <Box sx={{maxHeight:"100%"}}>

            {groupUsers?.length === 0 &&
              <Box sx={{
                display:"flex",
                alignItems:"center",
                justifyContent:"space-around",
                padding:"10px 20px",
                borderTop:"1px solid #a7a7a757",
                "& span" : {
                  width:"100%",
                  fontSize:"14px"
                },
              }}>
                <span style={{textAlign:"center", fontWeight:"bold"}}>Pas d'utilisateurs</span>
              </Box>
            }
            {groupUsers?.length > 0 &&
              <>
                {actResults?.map((user, index) => {
                  return (
                    <Box key={index} sx={{
                      display:"flex",
                      alignItems:"center",
                      justifyContent:"space-around",
                      padding:"10px 20px",
                      borderTop:"1px solid #a7a7a757",
                      "& span" : {
                        width:"100%",
                        fontSize:"13px"
                      },
                    }}>
                      <span>{user?.name}</span>
                      {user?.res?.map((res, index2) => {
                        return (
                          <span key={index2}>
                            {res?.statut === "notFind" && "•"}
                            {res?.statut === "inProgress" &&
                              <>
                                En cours <br />
                                {res?.progress}%
                              </>
                            }
                            {res?.statut === "ended" &&
                              <>
                                Terminée <br />
                                {/* 07/10/2026 : le score est la moyenne des categories, plus le
                                    total des points : « (x / y points) » le contredisait
                                    (« 50 % (0 / 0 points) »). */}
                                Score de {res?.score} %
                              </>
                            }
                          </span>
                        )
                      })}
                    </Box>
                  )
                })}
              </>
            }
          </Box>
      </Box>

    </>
  )
};

export default UsersResult ;
